import React from "react";
import { Button, Text, Grid, Flex, Select } from "@mantine/core";
import dayjs from "dayjs";
import { IconSquareFilled } from "@tabler/icons-react";

const TimeSlots = ({
  startTime = "09:00",
  endTime = "21:00",
  onSelect,
  isEmail = false,
}) => {
  const times = [];

  // Always show from 9:00 AM to 9:00 PM (9:00 to 21:00)
  const displayStartHour = isEmail ? 0 : 9;
  const displayEndHour = isEmail ? 23 : 21;
  const displayEndMinute = isEmail ? 45 : 0; // For emails, go until 11:45 PM

  // Parse the actual allowed start and end times for validation
  const [allowedStartHour, allowedStartMinute] = startTime
    .split(":")
    .map(Number);
  const [allowedEndHour, allowedEndMinute] = endTime.split(":").map(Number);

  // Convert allowed times to minutes for comparison
  const allowedStartMinutes = allowedStartHour * 60 + allowedStartMinute;
  const allowedEndMinutes = allowedEndHour * 60 + allowedEndMinute;

  // Generate times in 15-minute intervals from 9:00 AM to 9:00 PM
  let currentMinutes = displayStartHour * 60; // Start at 9:00 AM
  const displayEndMinutes = displayEndHour * 60 + displayEndMinute; // End at 11:45 PM for emails

  while (currentMinutes <= displayEndMinutes) {
    const hour = Math.floor(currentMinutes / 60);
    const minute = currentMinutes % 60;

    // Skip times after 11:45 PM for emails
    if (isEmail && (hour > 23 || (hour === 23 && minute > 45))) {
      currentMinutes += 15;
      continue;
    }

    // Format with AM/PM
    const timeString = dayjs().hour(hour).minute(minute).format("h:mm A");

    // Check if time is within allowed window
    const timeInMinutes = hour * 60 + minute;
    const isDisabled =
      timeInMinutes < allowedStartMinutes || timeInMinutes > allowedEndMinutes;

    times.push({
      value: dayjs().hour(hour).minute(minute).format("HH:mm"),
      label: timeString,
      disabled: isDisabled,
    });

    currentMinutes += 15;
  }

  const availableColor = "blue";
  const data = times.map((time) => ({
    value: time.value,
    label: time.label,
    disabled: time.disabled,
  }));

  return (
    <Select
      data={data}
      onChange={(e) => onSelect(e)}
      placeholder="Select a time"
      size="lg"
      // label="Select a time"
      required
    />
  );

  return (
    <div>
      <Flex gap="xl" justify="center" mb="lg">
        <Flex align="center" gap="xs">
          <IconSquareFilled
            size={16}
            style={{ color: `var(--mantine-color-${availableColor}-6)` }}
          />
          <Text size="sm">Available</Text>
        </Flex>
        <Flex align="center" gap="xs">
          <IconSquareFilled
            size={16}
            style={{ color: "var(--mantine-color-gray-3)" }}
          />
          <Text size="sm">Unavailable</Text>
        </Flex>
      </Flex>
      <Grid gutter="sm">
        {times.map((time, index) => (
          <Grid.Col span={3} key={index}>
            <Button
              radius="lg"
              size="compact-md"
              fullWidth
              color={availableColor}
              disabled={time.disabled}
              onClick={() => onSelect(time.value)}
            >
              {time.label}
            </Button>
          </Grid.Col>
        ))}
      </Grid>
    </div>
  );
};

export default TimeSlots;
